export default __webpack_public_path__ + "static/media/안주2.f8f4b2bd.png";